import { Link } from "@mui/material";

import { routes } from "@/global/routes";
import { faqs, howItWorks, purchaseSeatsLanguages } from "./helpers";
import { vendorUUIDs } from "../../constants";
import {
  DefaultRegistrationTerms,
  DefaultCheckoutTerms,
} from "../../default_terms_and_conditions";

import type { TeamConfig } from "@/global/hooks/useTeamConfig";

import AuthBanner from "public/images/stlouisblues/stlouis3.png";
import LogoImage from "public/images/stlouisblues/STL_Blue Note Primary_Light Background.png";
import FindGamesBanner from "public/images/stlouisblues/Flex Plan Web Banner+Game Tile Exports_Flex Plan Website Banner.png";

const config: TeamConfig = {
  teamSchema: "stlouisblues_flex",
  browserTitle: "St. Louis Blues Flex Plans",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  manageCard: true,
  teamName: "St. Louis Blues",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10208-blues-sec",
    mapId: "main",

    customSectionNameFontSize: 11,
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.giftCard,
  },

  // disabled routes
  disabledRoutes: [],

  phoneNumber: "",

  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: false,
  inventoryType: "SEAT-LEVEL",

  // purchase seat configs
  purchaseSeatConfigs: {
    minGameSelectionCount: 6,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,

    // show additional details fields at checkout form
    isCheckoutAdditionalDetailsEnabled: false,
    showFrontendTotalAmount: false,
    showFrontendServiceFee: false,

    hideViewTicketsInThankYouPage: false,
    defaultSeatCount: 2,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: false,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: 3,
    allowedPaymentFailCount: 3,
  },
  isSaveCardAllowed: true,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "https://flex.attendevents.com/stlouisblues_flex",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/blues/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: AuthBanner.src,
    checkoutStatusPageImage: AuthBanner.src,
    giftCardStandalonePageImage: FindGamesBanner.src,
    logoImage: LogoImage.src + "?width=76&height=76",
    logoNameImage: "",
    faviconImage: LogoImage.src,
    seatMap3dPreviewImage: "",
  },

  colors: {
    primary: "#002F87",
  },

  howItWorks,
  faqs,

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },

    customAdaLabel: (
      <>
        For accessible seating, please call the ticket office at{" "}
        <Link
          href="tel:3146222583"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (314) 622-2583
        </Link>
        .
      </>
    ),
  },

  languages: {
    topNavMenuItems: <></>,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: purchaseSeatsLanguages,
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription: "Thank you for your St. Louis Blues purchase!",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
